module.exports = __webpack_public_path__ + "static/media/Master-Typicle.e127a2c4.webp";